import React from "react";
import {ReplaceElement} from "../../../models/operations/ReplaceElement";
import {ProcessStep} from "../../../models/ProcessStep";
import {EElementType} from "../../../models/utils/EElementType";
import ElementService from "../../ElementService";
import SelectElementTypeStep from "../../../components/steps/select/SelectElementTypeStep";
import {AElement} from "../../../models/elements/AElement";
import StepsAccordingToSpecificationsService from "../StepsAccordingToSpecificationsService";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class ElementReplacementSteps {

    public getElementReplacementSteps(operation: ReplaceElement, setOperation: (operation: ReplaceElement) => void): ProcessStep[] {
        let steps: ProcessStep[] = [];
        steps.push(this.getSelectElementTypeStep(operation, setOperation));
        steps = steps.concat(this.getOldElementIdentificationStep(operation, setOperation));
        steps = steps.concat(this.getNewElementIdentificationStep(operation, setOperation));
        return steps;
    }

    private getOldElementIdentificationStep(operation: ReplaceElement, setOperation: (operation: ReplaceElement) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const element = operation.oldElement;
        const setElement = (element: AElement) => {
            operation.oldElement = element;
            setOperation(operation);
        }
        if(element) {
            steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(element.type, setElement, element, "steps.titles.identification-old"));
        }
        return steps;
    }

    private getNewElementIdentificationStep(operation: ReplaceElement, setOperation: (operation: ReplaceElement) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const element = operation.newElement;
        const setElement = (element: AElement) => {
            operation.newElement = element;
            setOperation(operation);
        }
        if(element) {
            steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(element.type, setElement, element, "steps.titles.identification-new"));
        }
        return steps;
    }

    private getSelectElementTypeStep(operation: ReplaceElement, setOperation: (operation: ReplaceElement) => void) {
        const setElementType = (elementType: EElementType) => {
            if(operation.oldElement === undefined || operation.oldElement.type !== elementType) {
                operation.oldElement = ElementService.createsElementAccordingToType(elementType);
                setOperation(operation);
            }

            if(operation.newElement === undefined || operation.newElement.type !== elementType) {
                operation.newElement = ElementService.createsElementAccordingToType(elementType);
                setOperation(operation);
            }
        }
        return new ProcessStep("steps.titles.replace-element", this.getSelectElementTypeComponent(setElementType, operation.oldElement?.type));
    }

    private getSelectElementTypeComponent(setElementType: (elementType: EElementType) => void, elementType?: EElementType) {
        return <SelectElementTypeStep initialElementType={elementType} onValidate={setElementType}/>
    }
}

export default new ElementReplacementSteps();
